//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import QRCode from 'qrcodejs2';
// import VueAwesomeSwiper from 'vue-awesome-swiper'
const { Swiper, SwiperSlide } = require('vue-awesome-swiper').default
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      qrcode: null,
      currentIdx: 0,
      lists: [
        { 
          key: 0,
          name: '成语故事动画屋',
          icon: require('../assets/images/show/chengyu.png'),
          des: '成语故事动画屋是中华语言文化凝聚的精华，每个成语故事中蕴藏着丰富的知识和深刻的人生哲理。这是一款专门为幼儿精心设计的成语学习APP，以动画讲解的形式诠释一个个耳熟能详的成语故事。让孩子从小学习成语，在故事中提升认知，丰富词汇积累，提升语言能力。精选的成语故事语言生动、通俗易懂，帮助孩子了解历史，感受到中华传统文化的独特魅力。', 
          characteristic: [
            "精选成语故事 生动有趣寓教于乐",
            "精美动画插画 激发宝宝学习兴趣",
            "全新语音讲解 日积月累加深记忆",
            "听故事学成语 丰富宝宝词汇积累",
          ],
          color: '#ffffff', 
          url: 'https://oss.idourl.com/upload/20210303/73bc1c2de47b4b418eee6ecc83d06391.png',
          download: 'http://calculator.h5.idotools.com/#/teachingAssistantSeries/com.idostudy.picture'
        }
      ],
      swiperOption: {
				//是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
				notNextTick: true,
        pagination: '.swiper-pagination',
        slidesPerView: 'auto',
        centeredSlides: true,
        paginationClickable: true,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        spaceBetween: 30,
        onSlideChangeEnd: swiper => {
          //这个位置放swiper的回调方法
          this.currentIdx = swiper.realIndex;
          // this.qrcode.clear(); // 清除代码
          // this.qrcode.makeCode(this.lists[swiper.realIndex].url); // 生成另外一个二维码
        }
      }  
    }
  },
  //定义这个sweiper对象
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
  },
  methods: {
    returnBackground (idx) {
      return `background: url(${require(`../assets/images/jiaofu_${idx}.png`)}) no-repeat 0 0;background-size: 100% 100%;`
    },
    routerGoDownload (url) {
      window.location.href = url
    },
    clickSlideTo (i) {
      this.currentIdx = i;
      this.swiper.slideTo(i, 0, false);

      // this.qrcode.clear(); // 清除代码
      // this.qrcode.makeCode(this.lists[i].url); // 生成另外一个二维码
      // this.bindQRCode(this.lists[i].url)
    },
    bindQRCode (url) {
      this.qrcode = new QRCode(this.$refs.qrCodeDiv, {
        text: url,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      })
    }
  },
  mounted () {
    //这边就可以使用swiper这个对象去使用swiper官网中的那些方法
    console.log('this.swiper', this.swiper)
    this.swiper.slideTo(0, 0, false);
    // this.bindQRCode(this.lists[0].url)
  }
}



// WEBPACK FOOTER //
// ./src/router/Show.vue